import type { RouteObject } from "react-router-dom";
import { ReportPage } from "./ReportPage";
import { ReportsPage } from "./ReportsPage";
import { RequireView } from "../payroll/kit";
import { areaAllows } from "../../app/nav";

export const routes: RouteObject[] = [
  { path: "reports", element: <RequireView allow={(h) => areaAllows("reports", h)}><ReportsPage /></RequireView> },
  { path: "reports/:name", element: <RequireView allow={(h) => areaAllows("reports", h)}><ReportPage /></RequireView> },
];
